import React, { useState } from "react";
import { DelayInput } from "react-delay-input/lib/Component";
import DatePicker from "react-date-picker";
import DefaultButton from "../../styles/materialButtonStyle";
import { DateToTimestamp, TimestampToDate } from "../../../utils/timestampToDate";
import ProjectsSelect from "../../elements/projects/ProjectsSelect";
import RiskScoreStatusSelect from "../../elements/riskScore/RiskScoreStatusSelect";
import RiskScoreCurrencySelect from "../../elements/riskScore/RiskScoreCurrencySelect";
import Dropdown from "rc-dropdown";
import { useTranslation } from "react-i18next";

import { StyledDatepicker } from "../../styles/styledDatepicker";
import {
  StyledFilterBlock,
  StyledFilterBlockTitle,
  StyledFilterCloseBtn,
  StyledFilterDropdownWrapper,
  StyledFilterGroup,
  StyledFilterWrapper,
  StyledSelectGroup,
  StyledShowFilterBtn
} from "../../elements/filter/styledFiter";

const RiskScoreFilter = ({ filterData, setFilterData }) => {
  const { t } = useTranslation("riskScorePage");

  const DEFAULT_FILTER_DATA = {
    "page": 1,
    "attributes.value.address": "",
    "attributes.value.txhash": "",
    "flowData.value[lte]": "",
    "flowData.value[gte]": "",
    "itemsPerPage": filterData["itemsPerPage"] ?? null
  };

  const [visible, setVisible] = useState(false);

  const onVisibleChange = (visible) => {
    setVisible(visible);
  };

  const handleClearFilter = () => {
    setFilterData(DEFAULT_FILTER_DATA);
  };

  const FilterList = () => {
    return (
      <>
        {visible &&
        <StyledFilterDropdownWrapper>
          <StyledFilterBlock actions>
            <StyledFilterGroup className="clear-btn">
              <DefaultButton
                color="transparent"
                onClick={handleClearFilter}
              >
                {t("filter.clearBtn")}
              </DefaultButton>
            </StyledFilterGroup>
            <StyledFilterGroup className="close-btn">
              <StyledFilterCloseBtn onClick={() => setVisible(false)} />
            </StyledFilterGroup>
          </StyledFilterBlock>
          <StyledFilterBlockTitle>
            {t("filter.filterBy")}:
          </StyledFilterBlockTitle>
          <StyledFilterBlock col="2">
            <StyledSelectGroup>
              <ProjectsSelect
                checkedProjects={filterData["connection.project.name"]}
                setCheckedProjects={(data) => setFilterData({
                  ...filterData,
                  "connection.project.name": data,
                  page: 1
                })}
                isObject={false}
                defaultOption={true}
              />
            </StyledSelectGroup>
            <StyledSelectGroup>
              <RiskScoreCurrencySelect
                checkedCurrency={filterData["attributes.value"]}
                setCheckedCurrency={(data) => setFilterData({ ...filterData, "attributes.value": data, page: 1 })}
                defaultOption={true}
              />
            </StyledSelectGroup>
            <StyledSelectGroup>
              <RiskScoreStatusSelect
                checkedStatus={filterData["status.value"]}
                setCheckedStatus={(data) => setFilterData({ ...filterData, "status.value": data, page: 1 })}
                defaultOption={true}
              />
            </StyledSelectGroup>
            <StyledFilterGroup>
              <label htmlFor="address">
                {t("filter.address")}
              </label>
              <DelayInput
                id="address"
                delayTimeout={2000}
                onChange={event => setFilterData({
                  ...filterData,
                  "attributes.value": event.target.value,
                  page: 1,
                  "attributes.value.address": event.target.value
                })}
                name="address"
                value={filterData["attributes.value.address"]}
                type="text"
              />
            </StyledFilterGroup>
            <StyledFilterGroup>
              <label htmlFor="txhash">Tx-hash</label>
              <DelayInput
                id="txhash"
                delayTimeout={2000}
                onChange={event => setFilterData({
                  ...filterData,
                  "attributes.value": event.target.value,
                  page: 1,
                  "attributes.value.txhash": event.target.value
                })}
                name="txhash"
                value={filterData["attributes.value.txhash"]}
                type="text"
              />
            </StyledFilterGroup>
          </StyledFilterBlock>
          <StyledFilterBlockTitle>
            {t("filter.risk")}:
          </StyledFilterBlockTitle>
          <StyledFilterBlock col="2">
            <StyledFilterGroup>
              <label htmlFor="riskScore[gte]">
                {t("filter.riskFrom")}
              </label>
              <DelayInput
                id="riskScore[gte]"
                delayTimeout={2000}
                onChange={event => setFilterData({ ...filterData, "flowData.value[gte]": event.target.value, page: 1 })}
                name="riskScore[gte]"
                value={filterData["flowData.value[gte]"]}
                type="number"
                step={0.1}
                min={0}
                max={1}
              />
            </StyledFilterGroup>
            <StyledFilterGroup>
              <label htmlFor="riskScore[lte]">
                {t("filter.riskTo")}
              </label>
              <DelayInput
                id="riskScore[lte]"
                delayTimeout={2000}
                onChange={event => setFilterData({ ...filterData, "flowData.value[lte]": event.target.value, page: 1 })}
                name="riskScore[lte]"
                value={filterData["flowData.value[lte]"]}
                type="number"
                step={0.1}
                min={0}
                max={1}
              />
            </StyledFilterGroup>
          </StyledFilterBlock>
          <StyledFilterBlockTitle>
            {t("filter.date")}:
          </StyledFilterBlockTitle>
          <StyledFilterBlock col="2">
            <StyledDatepicker>
              <label htmlFor="dateFrom">
                {t("filter.dateFrom")}
              </label>
              <DatePicker
                format="dd-MM-y"
                id="dateFrom"
                name="dateFrom"
                className="date-input"
                onChange={dateFrom => setFilterData({
                  ...filterData,
                  "createdAt[gte]": DateToTimestamp(dateFrom),
                  page: 1
                })}
                value={TimestampToDate(filterData["createdAt[gte]"])}
              />
            </StyledDatepicker>
            <StyledDatepicker>
              <label htmlFor="dateTo">
                {t("filter.dateTo")}
              </label>
              <DatePicker
                format="dd-MM-y"
                id="dateTo"
                name="dateTo"
                className="date-input"
                onChange={dateTo => setFilterData({
                  ...filterData,
                  "createdAt[lte]": DateToTimestamp(dateTo),
                  page: 1
                })}
                value={TimestampToDate(filterData["createdAt[lte]"])}
              />
            </StyledDatepicker>
          </StyledFilterBlock>
        </StyledFilterDropdownWrapper>}
      </>
    );
  };

  return (
    <StyledFilterWrapper id="filter">
      <Dropdown
        getPopupContainer={() => document.getElementById("filter")}
        overlay={FilterList}
        trigger={["click"]}
        placement="bottomLeft"
        onVisibleChange={onVisibleChange}
        visible={visible}
        closeOnSelect={false}
      >
        <StyledShowFilterBtn>
          <DefaultButton
            color="success"
          >
            {t("filter.filterBtn")}
          </DefaultButton>
        </StyledShowFilterBtn>
      </Dropdown>
    </StyledFilterWrapper>
  );
};

export default RiskScoreFilter;